<script>
export default {
    name: 'ContactSection',
};
</script>

<template>
    <section class="contact">
        <article class="contact__article">
            <h1 class="contact__article__title">{{ $t('contact.title') }}</h1>
            <p class="contact__article__paragraph">
                Paul Philipp Hug <br>
                <ul class="contact__article__links">
                    <li class="contact__article__link">
                        <a href="https://www.linkedin.com/in/paul-philipp-hug" target="_blank">
                            <img class="contact__image" src="../assets/images/logo-linkedin.svg" alt="Logo LinkedIn">
                            <img class="contact__image--negative" src="../assets/images/logo-linkedin-negative.svg" alt="Logo LinkedIn">
                        </a>
                    </li>
                    <li class="contact__article__link">
                        <a href="https://www.xing.com/profile/PaulPhilipp_Hug/cv" target="_blank">
                            <img class="contact__image" src="../assets/images/logo-xing.svg" alt="Logo XING">
                            <img class="contact__image--negative" src="../assets/images/logo-xing-negative.svg" alt="Logo XING">
                        </a>
                    </li>
                </ul>
            </p>
            <p class="contact__article__paragraph">
                Andreas Tobler <br>
                <ul class="contact__article__links">
                    <li class="contact__article__link">
                        <a href="https://www.linkedin.com/in/andreastobler" target="_blank">
                            <img class="contact__image" src="../assets/images/logo-linkedin.svg" alt="Logo LinkedIn">
                            <img class="contact__image--negative" src="../assets/images/logo-linkedin-negative.svg" alt="Logo LinkedIn">
                        </a>
                    </li>
                    <li class="contact__article__link">
                        <a href="https://www.xing.com/profile/Andreas_Tobler/cv" target="_blank">
                            <img class="contact__image" src="../assets/images/logo-xing.svg" alt="Logo XING">
                            <img class="contact__image--negative" src="../assets/images/logo-xing-negative.svg" alt="Logo XING">
                        </a>
                    </li>
                </ul>
            </p>
        </article>
    </section>
</template>

<style lang="scss" scoped>
@import '../styles/variables';
.contact {
    display: flex;
    height: 48rem;

    @media (max-width: 960px) {
        height: auto;
        margin-bottom: 23rem;
    }

    @media (max-width: 760px) {
        margin-bottom: 16rem;
    }
}
.contact__article {
    box-sizing: border-box;
    width: 17.1875rem;
    margin: 0 auto;
    padding: 1.2rem 0.78125rem;
    font-size: 1.125rem;
    line-height: 1.222;
    color: $color-light;
    z-index: 4;

    @media (max-width: 960px) {
        margin: 3rem auto;
        color: $color-primary;
    }
}
.contact__article__title {
    margin: 0 0 2rem;
    font-size: 1.125rem;
    line-height: 1.222;
    text-transform: uppercase;
    font-weight: normal;
}
.contact__article__title:after {
    content: "";
    display: block;
    width: 2.3551875rem;
    height: .09rem;
    background: $color-light;
    margin: .5rem 0 0 1.625rem;

    @media (max-width: 960px) {
        background: $color-primary;
    }
}
.contact__article__paragraph {
    margin: 0 0 1rem;
}
.contact__article__paragraph a {
    color: $color-primary;
    text-decoration: none;
}
.contact__article__links {
    display: flex;
    margin: .25rem 0 0;
    padding: 0;
}
.contact__article__link {
    list-style: none;
    margin-right: .5625rem;
}
.contact__article__link a img {
    border: none;
}
.contact__image {
    display: none;

    @media (max-width: 960px) {
        display: inline-block;
    }
}
.contact__image--negative {
    display: inline-block;

    @media (max-width: 960px) {
        display: none;
    }
}
</style>
